import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateActivityStageMutation as CreateActivityStageMutationType,
  CreateActivityStageMutationVariables,
} from "./__generated__/CreateActivityStageMutation";

const CreateActivityStageMutation = loader("./CreateActivityStageMutation.gql");

type CreateActivityStageMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateActivityStageMutationType) => void;
}) => ReactElement;

export const CreateActivityStageMutationProvider: CreateActivityStageMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateActivityStageMutationType, CreateActivityStageMutationVariables>(
    CreateActivityStageMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
